import React, {PureComponent} from 'react';
import {Form, Icon, Input} from 'antd';
import {RTLCol} from '../RTLKit';


export default class TextField extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        const {
            input,
            label,
            iconName,
            type,
            defaultValue,
            placeholder,
            disabled,
            help,
            required,
            meta: {touched, error, warning},
        } = this.props;

        let value = defaultValue
        if(input.value)
            value = input.value

        return (
            <RTLCol span={24}>
                <RTLCol className="formLabel" md={label ? 5 : 0} sm={24}>
                    {label ? <label>{label} : </label> : null}
                </RTLCol>
                <RTLCol md={label ? 15 : 19} sm={24}>
                    <Form.Item hasFeedback validateStatus={(touched && error) ? 'error' : ''} >
                        <Input
                            {...input}
                            prefix={<Icon type={iconName} style={{color: 'rgba(0,0,0,.25)'}}/>}
                            placeholder={ placeholder}
                            type={type}
                            disabled={disabled}
                            value={value}
                            required={required}
                        />
                        {help ?
                            <span className="settingsHelp">
                                {help}
                            </span>
                        : null}
                    </Form.Item>
                </RTLCol>
                <RTLCol md={3} sm={24}>
                    {touched &&
                    ((error && <span className="errorMsg">{error}</span>) ||
                        (warning && <span className="warningMsg">{warning}</span>))}
                </RTLCol>
            </RTLCol>
        );
    }
}



